


const UploadFileSVG = () => {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3_38841)">
<path d="M6.99996 18.0002C5.75223 18.0002 4.55561 17.5261 3.67334 16.6822C2.79107 15.8383 2.29541 14.6937 2.29541 13.5002C2.29541 12.3067 2.79107 11.1621 3.67334 10.3182C4.55561 9.4743 5.75223 9.0002 6.99996 9.0002C7.29464 7.68737 8.15672 6.53368 9.39654 5.79291C10.0104 5.42612 10.6986 5.17174 11.4217 5.04431C12.1449 4.91687 12.8888 4.91887 13.6111 5.0502C14.3333 5.18152 15.0198 5.43959 15.6312 5.80968C16.2427 6.17976 16.7672 6.65461 17.1747 7.20712C17.5823 7.75963 17.8649 8.37898 18.0065 9.02979C18.1481 9.68061 18.1459 10.3502 18 11.0002H19C19.9282 11.0002 20.8185 11.3689 21.4748 12.0253C22.1312 12.6817 22.5 13.5719 22.5 14.5002C22.5 15.4285 22.1312 16.3187 21.4748 16.9751C20.8185 17.6314 19.9282 18.0002 19 18.0002H18" stroke="#484848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 15L12 12L15 15" stroke="#484848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 12V21" stroke="#484848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_3_38841">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
  )
}

export default UploadFileSVG

